import React, { useState } from "react";
import Navbar from "./Navbar";
import Mainpage from "./Mainpage";
import Thirdsection from "./Thirdsection";
import Fourthsection from "./Fourthsection";
import Fifthsection from "./Fifthsection";
import Footer from "./Footer";

function home() {
  return (
    <>
       <div className="ntg"></div>
    </>
  );
}

export default home;
